import React from "react";
import { useFormik } from "formik";
import * as yup from "yup";
import { Box, TextField, FormHelperText, Button } from "@mui/material";
import CustomButton from "components/Button";
import DialogComponent from "components/DialogComponent";
import { useRenameFileMutation } from "store/slices/apis/dmsSlice";
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { closeSnackbar, openSnackbar } from "store/slices/snackbar";

const RenameFile = ({ open, handleClose, fileId, currentName = "", onSuccess, extension }) => {
    console.log("Extension", extension)
    const { projectId } = useParams();
    const [renameFile, { isLoading }] = useRenameFileMutation({ projectId });
    const dispatch = useDispatch();
    const formik = useFormik({
        initialValues: {
            newFileName: currentName || "",
        },
        validationSchema: yup.object({
            newFileName: yup.string().required("File name is required").min(1),
        }),
        enableReinitialize: true,
        onSubmit: async (values) => {
            try {
                const formData = new FormData();
                formData.append("FileId", fileId);
                formData.append("NewFileName", `${values.newFileName}${extension}`);

                const result = await renameFile(formData).unwrap();
                if (result?.status === "Success") {
                    openNotification("File Renamed Successfully", "success")
                    onSuccess()
                    handleClose();
                }

            } catch (error) {
                openNotification(error?.data?.message || "File Renamed Failed")
                console.error("Rename failed:", error);
            }
        },
    });

    const openNotification = (msg, type = "error", duration = 5000) => {
        dispatch(
            openSnackbar({
                open: true,
                message: msg,
                variant: 'alert',
                alert: {
                    color: type
                },
                close: false
            })
        );
        setTimeout(() => dispatch(closeSnackbar()), duration);
    };

    return (
        <DialogComponent
            title="Rename File"
            open={open}
            handleClose={handleClose}
        >
            <form onSubmit={formik.handleSubmit}>
                <Box sx={{ p: 1 }}>
                    <TextField
                        fullWidth
                        name="newFileName"
                        label="New File Name"
                        value={formik.values.newFileName}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={
                            formik.touched.newFileName &&
                            Boolean(formik.errors.newFileName)
                        }
                        sx={{ mt: 1 }}
                    />
                    {formik.touched.newFileName && formik.errors.newFileName && (
                        <FormHelperText error>{formik.errors.newFileName}</FormHelperText>
                    )}
                </Box>

                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "flex-end",
                        gap: 1.5,
                        mt: 3,
                        pt: 2,
                        borderTop: "1px solid #F3F4F6",
                    }}
                >
                    {/* <CustomButton
                        label="Cancel"
                        onClick={handleClose}
                        sx={{
                            backgroundColor: "#F9FAFB",
                            color: "#4B5563",
                            border: "1px solid #E5E7EB",
                            "&:hover": { backgroundColor: "#F3F4F6" },
                        }}
                    /> */}
                    <Button onClick={handleClose}
                        sx={{
                            textTransform: "none",
                            color: "#F15744",
                            fontSize: "14px",
                            lineHeight: "100%",
                            fontFamily: "Outfit, sans-serif",
                            borderRadius: "25px",
                            fontWeight: 500,
                            px: "20px",
                            py: "15px",
                        }}>
                        Cancel
                    </Button>
                    {/* <CustomButton
                        label={isLoading ? "Renaming..." : "Rename"}
                        type="submit"
                        disabled={isLoading}
                        sx={{ backgroundColor: "#00344C", color: "#fff", px: 4 }}
                    /> */}
                    <Button
                        type="submit"
                        variant="contained"
                        loading={isLoading}
                        sx={{
                            backgroundColor: "#00344C",
                            borderRadius: "25px",
                            textTransform: "none",
                            fontWeight: 500,
                            fontSize: "14px",
                            lineHeight: "100%",
                            fontFamily: "Outfit, sans-serif",
                            color: "#FFFFFF",
                            px: "20px",
                            py: "15px",
                        }}
                        disabled={isLoading}
                    >
                        Save
                    </Button>
                </Box>
            </form>
        </DialogComponent>
    );
};

export default RenameFile;
